function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgTransport = function SvgTransport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 474.02899169921875 474.02899169921875",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Capa_1_1565829485181",
    width: 75,
    height: 75,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.004,264.002c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8s8-3.582,8-8v-32    C72.004,267.584,68.422,264.002,64.004,264.002z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.004,280.002c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8s8-3.582,8-8v-32    C104.004,283.584,100.422,280.002,96.004,280.002z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387.796,322.938c-3.729-2.37-8.673-1.267-11.043,2.462c-2.274,3.579-1.361,8.311,2.083,10.786    c21.99,14.806,27.813,44.635,13.008,66.624c-14.806,21.99-44.635,27.814-66.624,13.008c-21.99-14.806-27.814-44.635-13.008-66.624    c8.915-13.241,23.83-21.184,39.792-21.192c4.418,0,8-3.582,8-8s-3.582-8-8-8c-35.346,0.007-63.995,28.666-63.988,64.012    c0.007,35.346,28.666,63.995,64.012,63.988c35.346-0.007,63.995-28.666,63.988-64.012    C416.012,354.715,405.436,334.832,387.796,322.938z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.235,349.43c-7.751-26.851-26.823-48.989-52.231-60.628v-176.8c0.001-2.829-1.493-5.448-3.928-6.888l-176-104    c-2.512-1.485-5.633-1.485-8.144,0l-176,104c-0.168,0.096-0.288,0.24-0.448,0.352c-0.16,0.112-0.312,0.24-0.472,0.368    c-0.695,0.547-1.292,1.207-1.768,1.952c0,0.056-0.096,0.088-0.128,0.144v0.056c-0.451,0.813-0.757,1.698-0.904,2.616    c0,0.24-0.072,0.464-0.096,0.704s-0.112,0.456-0.112,0.696v208c-0.001,2.829,1.493,5.448,3.928,6.888l176,104    c0.211,0.102,0.427,0.193,0.648,0.272c0.218,0.109,0.443,0.205,0.672,0.288c1.761,0.736,3.743,0.736,5.504,0    c0.232-0.083,0.459-0.179,0.68-0.288c0.208-0.096,0.432-0.152,0.64-0.272l47.768-28.232c14.699,50.918,67.891,80.28,118.81,65.581    C429.572,453.541,458.934,400.348,444.235,349.43z M208.004,17.29l41.6,24.584l-61.68,36.448    c-3.806,2.249-5.069,7.158-2.82,10.964s7.158,5.069,10.964,2.82l69.272-40.904l41.6,24.584l-160.272,94.68l-41.6-24.584    l67.016-39.6c3.806-2.249,5.069-7.158,2.82-10.964c-2.249-3.806-7.158-5.069-10.964-2.82l-74.6,44.088l-41.608-24.584    L208.004,17.29z M138.668,184.33v53.416L97.34,213.322v-53.416L138.668,184.33z M259.165,351.272    c-2.128,8.07-3.191,16.384-3.161,24.73c0.002,3.348,0.178,6.694,0.528,10.024l-40.528,23.96v-25.984c0-4.418-3.582-8-8-8    s-8,3.582-8,8v25.984l-160-94.544V126.026L81.34,150.45v67.432c-0.003,2.832,1.49,5.455,3.928,6.896l57.328,33.88    c1.234,0.726,2.64,1.11,4.072,1.112c4.418,0,8-3.582,8-8v-57.992l45.336,26.792v131.432c0,4.418,3.582,8,8,8s8-3.582,8-8V220.57    l144.992-85.68c3.804-2.249,5.065-7.156,2.816-10.96c-2.249-3.804-7.156-5.065-10.96-2.816l-144.848,85.6l-45.6-26.952    L322.676,85.05l53.328,31.512v166.64C324.943,269.735,272.632,300.21,259.165,351.272z M352.004,456.002    c-44.183,0-80-35.817-80-80c0-44.183,35.817-80,80-80c44.183,0,80,35.817,80,80C431.956,420.165,396.167,455.953,352.004,456.002z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381.464,354.346c-3.1-2.995-8.016-2.995-11.116,0l-30.344,30.344l-6.344-6.344c-3.178-3.07-8.242-2.982-11.312,0.196    c-2.995,3.1-2.995,8.016,0,11.116l12,12c3.124,3.123,8.188,3.123,11.312,0l36-36C384.73,362.48,384.642,357.415,381.464,354.346z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transport.499d0406.svg";
export { ForwardRef as ReactComponent };